import React from 'react'
import { Popconfirm, Button } from 'antd'
import { DeleteOutlined } from '@ant-design/icons';

export default class DeleteConfirmButton extends React.PureComponent {
  render() {
    const { onConfirm, loading = false } = this.props
    
    return (
      <Popconfirm
        title="確認要刪除嗎？"
        okText="確認刪除"
        cancelText="取消"
        okButtonProps={{ type: 'danger' }}
        onConfirm={onConfirm}
      >
        <Button
          type="default"
          danger
          size={this.props.size}
          loading={this.props.loading}
          icon={<DeleteOutlined />}
        >刪除</Button>
      </Popconfirm>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DeleteConfirmButton/DeleteConfirmButton.js